/* External */
import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Components */
import FocusableButton from '../FocusableButton';

/* Utils */
import { useOnBackPress } from '../../utils/keyDownEvents';
import { CONFIRMATION } from '../../utils/focusKey';
import { noOp } from '../../utils/functions';

/* Styles */
import './Confirmation.scss';

function Confirmation({
  acceptTranslationId,
  cancelTranslationId,
  messageTranslationId,
  onAcceptPress,
  onCancelPress,
  realFocusKey,
  setFocus,
}) {
  const acceptFocusKey = `${realFocusKey}-${CONFIRMATION.ACCEPT}`;

  useEffect(() => {
    setFocus(acceptFocusKey);
  }, [acceptFocusKey, setFocus]);

  useOnBackPress({ listener: onCancelPress });

  return (
    <div className="dtv-html5-c-confirmation">
      <p className="dtv-html5-c-confirmation__message">
        <FormattedMessage id={messageTranslationId} />
      </p>
      <div className="dtv-html5-c-confirmation__buttons">
        <FocusableButton
          primary
          focusKey={acceptFocusKey}
          onEnterPress={onAcceptPress}
        >
          <FormattedMessage id={acceptTranslationId} />
        </FocusableButton>
        <FocusableButton
          primary
          onEnterPress={onCancelPress}
        >
          <FormattedMessage id={cancelTranslationId} />
        </FocusableButton>
      </div>
    </div>

  );
}

Confirmation.defaultProps = {
  acceptTranslationId: '',
  cancelTranslationId: '',
  messageTranslationId: '',
  onAcceptPress: noOp,
  onCancelPress: noOp,
  realFocusKey: '',
  setFocus: noOp,
};

Confirmation.propTypes = {
  acceptTranslationId: PropTypes.string,
  cancelTranslationId: PropTypes.string,
  messageTranslationId: PropTypes.string,
  onAcceptPress: PropTypes.func,
  onCancelPress: PropTypes.func,
  realFocusKey: PropTypes.string,
  setFocus: PropTypes.func,
};

export default memo(withFocusable()(memo(Confirmation)));
